import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "ngx-dialog-receipt-cancel",
  templateUrl: "dialog-receipt-cancel.component.html",
  styleUrls: ["dialog-receipt-cancel.component.scss"],
})
export class DialogReceiptCancelComponent implements OnInit {
  @Input() title: string;

  reason: string;
  diaForm: FormGroup;
  submitted = false;
  loading = false;

  constructor(
    protected ref: NbDialogRef<DialogReceiptCancelComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    const reasonValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    this.diaForm = this.fb.group({
      reason: ["", reasonValidators],
    });
  }

  cancel() {
    this.ref.close();
  }

  submit() {
    this.ref.close(this.reason);
  }
}
